<template lang="pug">
transition(name="modal")
  div(:class="$style.modalOverlay")
    div(:class="$style.modalWrapper")
      div(:class="$style.modalHeader")
        button(:class="$style.modalDefaultButton", @click="copyToBuffer") {{ $t('T_COPY_TO_CLIPBOARD') }}
        button(:class="$style.modalDefaultButton", @click="$emit('close')") {{ $t('T_CLOSE') }}
      div(:class="$style.modalBody")
        table
          tr
            td {{ $t('T_FRONTEND_VERSION') }}
            td
              strong {{frontend_version}}
          tr
            td {{ $t('T_BACKEND_VERSION') }}
            td
              strong {{backend_version}}
          tr
            td {{ $t('T_UCCE_INTEGRATION') }}
            td
              strong {{ucceIntegrationState}}
          tr(v-if="ucceEnabled && isFrame")
            td {{ $t('T_UCCE_GADGET_VERSION') }}
            td
              strong {{ucceVersion}}
          tr
            td {{ $t('T_BROWSER_VERSION') }}
            td
              strong {{userAgent}}
          tr
            td {{ $t('T_URL') }}
            td
              strong {{location}}
          tr
            td {{ $t('T_USER_NAME') }}
            td
              strong {{$store.state.home.user.name}}
          tr
            td {{ $t('T_USER_ROLE') }}
            td
              strong {{$store.state.home.user.role}}
        table
          caption Local storage:
          template(v-for="(val, key) in ls")
            tr
              td {{key}}
              td
                xmp {{val}}
        table
          caption Vuex state:
          template(v-for="(val, key) in $store.state")
            tr
              td {{key}}
              td
                xmp {{JSON.stringify(val, null, 2)}}

</template>

<script>
import {
  mapActions, mapState, mapMutations,
} from 'vuex';
import { version, l } from 'src/utils';
import { UCCE_VERSION } from 'src/store/modules/app';

export default {
  created() {
    if (this.isFrame) window.addEventListener('message', this.changeUcceVersionOnParentWindow);
  },
  async mounted() {
    this.frontend_version = await version.frontend();
    this.backend_version = await version.backend();
    await this.getUcceIntegration().then(() => {
      if (this.ucceEnabled && this.isFrame) {
        window.parent.postMessage(JSON.stringify({
          type: 'iframeLoaded',
          data: {
            msg: 'iframeLoaded',
          },
        }), '*');
      }
    });
    this.userAgent = navigator.userAgent;
    for (let i = 0; i < localStorage.length; i += 1) {
      this.ls[localStorage.key(i)] = localStorage.getItem(localStorage.key(i));
    }
    window.addEventListener('keyup', this.onKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onKeyUp);
  },
  destroyed() {
    if (this.isFrame) window.removeEventListener('message', this.changeUcceVersionOnParentWindow);
  },
  computed: {
    ...mapState('home', ['ucceIntegration']),
    ...mapState('app', ['isFrame']),
    ucceEnabled() {
      return this.ucceIntegration;
    },
    ucceVersion() {
      return this.$store.state.app[UCCE_VERSION];
    },
    ucceIntegrationState() {
      return this.ucceIntegration ? `${this.$t('T_ON')}` : `${this.$t('T_OFF')}`;
    },
  },
  methods: {
    ...mapMutations('app', ['CHANGE_UCCE_VERSION']),
    ...mapActions('home', ['getUcceIntegration']),
    onKeyUp(zEvent) {
      if (zEvent.which === 27) {
        this.$emit('close');
      }
    },
    copyToBuffer() {
      const textarea = document.createElement('textarea');
      textarea.style = 'visibility: false; height: 1px;';
      textarea.value = document.querySelector('.modal-body').innerText;
      const copyTextarea = document.querySelector('.modal-body').appendChild(textarea);

      copyTextarea.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        l.warn(`Copying text command was ${msg}`);
      } catch (err) {
        l.warn('Oops, unable to copy');
      }
      document.querySelector('.modal-body').removeChild(textarea);
    },
    changeUcceVersionOnParentWindow(e) {
      const res = e.data;
      if (res.type === 'OnIframeLoaded') {
        this.CHANGE_UCCE_VERSION(res.data.ucceVersion);
      }
    },
  },

  data() {
    return {
      frontend_version: '',
      backend_version: '',
      userAgent: '',
      ls: {},
      location: window.location.href,
    };
  },
};
</script>

<style lang="sass" module>
.modalOverlay
  position: fixed
  z-index: 9000
  top: 0
  left: 0
  right: 0
  width: 100%
  height: 100%
  background-color: $color_bg_light_accent
  transition: opacity 0.3s ease

.modalWrapper
  position: absolute
  overflow: auto
  left: 32px
  right: 32px
  top: 32px
  bottom: 32px
  padding: 32px
  background-color: $white
  border-radius: 2px
  box-shadow: 0 2px 8px $color_social_disabled
  transition: all 0.3s ease

.modalHeader h3
  margin-top: 0
  color: $color_green

.modalBody
  margin: 20px 0
  table
    margin-top: 8px

  caption
    margin-bottom: 0px
    text-align: left

  table td
    vertical-align: top

  xmp
    font-size: 11px
    font-family: monospace

.modalDefaultButton
  margin-right: 8px
  background-color: buttonface
  border-color: buttonface

</style>

<style lang="sass">
.modal-enter
  opacity: 0

.modal-leave-active
  opacity: 0

.modal-enter .modal-container .modal-leave-active .modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)

</style>
